import React, { ReactElement, useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { useAppDispatch, useAppSelector } from 'src/store/hooks'
import { Alert, Box, Button, Container, Snackbar } from '@mui/material'
import { selectUserID } from '../settings/settings.slice'
import {
  fetchEvents,
  fetchQuiz,
  fetchQuizSessionQuestions,
  selectEventById,
  selectEventsStatus,
  selectSessionQuestionsByQuiz,
  selectSessionQuestionsStatusByQuiz,
  selectQuizByEvent,
  selectQuizStatusByEvent,
  fetchQuizSessionResult,
  selectQuizSessionResults,
  selectQuizSessionResultsStatus,
} from './events.slice'
import { QuizTaker } from 'src/v3/components/quiz/quiz-taker'
import Loading from 'src/v3/components/loading'

let TakeQuiz = (): ReactElement => {
  let dispatch = useAppDispatch()
  let navigate = useNavigate()
  let { eventId } = useParams()
  let eventID = eventId || ''

  let userID = useAppSelector(selectUserID)
  let event = useAppSelector(selectEventById(eventID))
  let eventsStatus = useAppSelector(selectEventsStatus)
  let quiz = useAppSelector(selectQuizByEvent(eventID))
  let quizStatus = useAppSelector(selectQuizStatusByEvent(eventID))
  let quizID = quiz?.id || ''
  let questions = useAppSelector(selectSessionQuestionsByQuiz(quizID))
  let questionsStatus = useAppSelector(
    selectSessionQuestionsStatusByQuiz(quizID),
  )
  let sessionResult = useAppSelector(selectQuizSessionResults(eventID))
  let sessionResultStatus = useAppSelector(
    selectQuizSessionResultsStatus(eventID),
  )

  let [errorMessage, setErrorMessage] = useState<string>('')

  useEffect(() => {
    if (eventsStatus === 'uninitialized') {
      dispatch(fetchEvents())
    }
  }, [eventsStatus])

  useEffect(() => {
    if ((eventID && !quizStatus) || quizStatus === 'uninitialized') {
      dispatch(fetchQuiz(eventID))
    }
  }, [quizStatus, eventID])

  useEffect(() => {
    if ((quizID && !questionsStatus) || questionsStatus === 'uninitialized') {
      dispatch(fetchQuizSessionQuestions({ quizID, userID }))
    }
  }, [questionsStatus, quizID])

  useEffect(() => {
    if (
      (eventID && !sessionResultStatus) ||
      sessionResultStatus === 'uninitialized'
    ) {
      dispatch(fetchQuizSessionResult(eventID))
    }
  }, [sessionResultStatus, eventID])

  return (
    <Container maxWidth="xl">
      <Box sx={{ mt: -18 }}></Box>
      {/* <Typography variant="h5" sx={{ mb: 3 }}>
        Event Quiz
      </Typography> */}
      <Box>
        <QuizTaker
          name={event?.name || 'Event'}
          quiz={quiz}
          questionData={questions}
          apiPath="/api/event"
          proceedButton={
            <Button
              variant="contained"
              onClick={() => {
                navigate(`/events/${eventID}/certificate`)
              }}
            >
              Complete Event
            </Button>
          }
          existingResult={sessionResult}
        />
      </Box>
      <Loading entities={[eventsStatus, quizStatus, questionsStatus]} />
      <Snackbar open={!!errorMessage} onClose={() => setErrorMessage('')}>
        <Alert
          variant="filled"
          onClose={() => setErrorMessage('')}
          severity="error"
        >
          {errorMessage}
        </Alert>
      </Snackbar>
    </Container>
  )
}

export default TakeQuiz
